export default {
	events: {
		specialsEvent: [
			{
				logic: ({ eventData: { specialType, widgetName } }) => {
					// wsm-specials-display renders promos as vehicle cards in ws-inv-listing
					const allowedWidgets = ['ws-specials', 'ws-inv-listing'];
					const allowedSpecialType = ['click', 'disclaimer click'];

					return (
						allowedWidgets.includes(widgetName) &&
						allowedSpecialType.includes(specialType)
					);
				},
				payload: {
					directCallEvent: 't3TrackOfferDetails',
					additionalData: {
						offerId: '[[eventData.specialId]]',
						offerText: '[[eventData.title]]'
					}
				}
			}
		]
	}
};
